import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import _get from 'lodash/get';
import Typography from '@material-ui/core/Typography';
import { Link, useLocation } from 'react-router-dom';
import Mixpanel from 'utils/mixpanelService';
import { useSelector } from 'react-redux';
import { makeSelectClientDetails } from 'containers/Main/selectors';

const useStyles = makeStyles(() => ({
  wrapper: {
    borderRadius: 8,
    boxShadow: '0rem 0.625rem 2rem -0.5rem rgb(0 0 0 / 16%)',
    '-webkit-box-shadow': '0rem 0.625rem 2rem -0.5rem rgb(0 0 0 / 16%)',
    backgroundColor: '#FFFFFF',
  },
  cardLink: {
    textDecoration: 'none',
    color: '#979797',
  },
  textContainer: {
    padding: '20px 16px',
    display: 'flex',
    flexDirection: 'column',
    height: 135,
    alignItems: 'center',
    flex: 1,
  },
  title: {
    width: '100%',
    display: '-webkit-box',
    '-webkit-line-clamp': '2',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 48 /* Fallback for non-webkit */,
    wordBreak: 'break-word',
    fontSize: 14,
    color: ({ titleColor }) => titleColor,
  },
  description: {
    width: '100%',
    display: '-webkit-box',
    marginTop: 7,
    fontSize: 12,
    '-webkit-line-clamp': '4',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxHeight: 72 /* Fallback for non-webkit */,
    wordBreak: 'break-word',
  },
}));

function TopicCard(props) {
  const {
    topicID,
    fields: { slug, title, description },
  } = props;
  const clientDetails = useSelector(makeSelectClientDetails());
  const classes = useStyles({
    titleColor: _get(clientDetails, 'metadata.plainCardTitleColor', '#0071BC'),
  });
  const location = useLocation();

  const redirect = () => {
    const pageName = location.pathname.split('/')[1];
    const finalPageName = pageName ? `${pageName}Page` : 'homePage';
    Mixpanel.track('Resource Card - Clicked', {
      name: title,
      type: 'topic',
      page: finalPageName,
      path: location.pathname.split('/')[1],
      slug: location.pathname.split('/')[2],
      entryId: topicID,
    });
  };
  const redirectUrl = `/topics/${slug}`;
  return (
    <Grid item xs={12} className={classes.wrapper}>
      <Link to={redirectUrl} onClick={redirect} className={classes.cardLink}>
        <Grid container>
          <Grid item xs={12}>
            <div className={classes.textContainer}>
              <Typography
                variant="h6"
                align="left"
                color="primary"
                className={classes.title}
              >
                {title}
              </Typography>
              <Typography
                align="left"
                color="textPrimary"
                className={classes.description}
              >
                {description}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Link>
    </Grid>
  );
}

TopicCard.propTypes = {
  topicID: PropTypes.string,
  fields: PropTypes.object,
};

export default TopicCard;
